import React from "react";

import { Sidebar } from "../../layout/Sidebar/Sidebar";
import Feed from "../../components/Portal/FeedPage/FeedPage";

const CommunityPage = () => {
  return (
    <>
      <Sidebar childComponent={<Feed />} activeText="Forum" />
    </>
  );
};

export default CommunityPage;
